import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ChevronDownIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <Path
      d="M2 5L8 11L14 5"
      stroke={color}
      strokeWidth="1.5"
    />
  </Svg>
);

ChevronDownIcon.displayName = 'ChevronDownIcon';
